// extracted by mini-css-extract-plugin
export default {"NavBlock":"NavBlock_NavBlock__LCEWx","errorMessage":"NavBlock_errorMessage__IEhlB","NavIcon":"NavBlock_NavIcon__jWHnu","invert":"NavBlock_invert__94hc8"};